export default defineNuxtPlugin(() => {
    const { gtag } = useGtag();
    const user = useState('user');
    const municipality = useCookie('municipality');

    const userProps = {};
    if(user.value?.subscription){
        userProps.role = user.value.subscription;
    }
    if(municipality.value && municipality.value !== 'none'){
        userProps.municipality = municipality.value;
    }
    if(user.value){
        if(user.value.is_demo){
            userProps.is_demo = user.value.is_demo;
        }
        else{
            userProps.is_demo = false;
        }
    }

    if(window.location.hostname === 'crowsnestpass.siteability.ca' || window.location.hostname === 'mississipimills.siteability.ca'){
        userProps.environ = 'prod';
    }else{
        userProps.environ = 'internal';
    }

    gtag('set', {
        user_properties: userProps
    })

})